<template>
  <card class="card" title="Edit Organization">
    <div>
      <form @submit.prevent>
        <div class="row">
          <div class="col">
            <fg-input type="text" label="Organization" placeholder="Organization Name" v-model="company.name">
            </fg-input>
          </div>
          <div class="col">
            <fg-input type="text" label="Website" placeholder="Organization Name" v-model="company.company_website">
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <fg-input type="text" label="City" placeholder="New York" v-model="company.city"> </fg-input>
          </div>
          <div class="col">
            <fg-input type="text" label="Country code" placeholder="US" v-model="company.country_code"> </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <label>Description (max: 255)</label>
            <textarea
              rows="3"
              class="form-control border-input"
              placeholder="Organization Description"
              maxlength="255"
              v-model="company.description"
            >
            </textarea>
          </div>
        </div>

        <div class="row justify-content-center">
          <p-button type="success" round @click.native.prevent="updateCompany(company)"> Update Profile </p-button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>
<script>
import Multiselect from 'vue-multiselect';
import axiosAuth from '../../../axiosMain';

export default {
  components: {
    Multiselect,
  },
  props: {
    company: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    updateCompany: function (company) {
      let data = {
        name: company.name,
        company_website: company.company_website,
        description: company.description,
        city: company.city,
        country_code: company.country_code,
      };
      this.$emit('update', data);
    },
  },
};
</script>

<style src="../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"></style>
<style></style>
